import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TextArea = () => {
  return <textarea name="textarea" style={{ width: "100%" }}></textarea>;
};

const EditableResultList = ({
  result,
  edit,
  setEdit,
  changeTo,
  setValue,
  indeks,
  property,
  changed,
  type,
  autosave,
  disable,
  placeholder,
  isPercentageMax100,
}) => {
  const [tempValue, setTempValue] = useState(changeTo);
  const [startDate, setStartDate] = useState(new Date());

  const handleEdit = () => {
    setEdit(true, indeks, property);
    setTempValue(changeTo);
  };
  const handleChange = (e) => {
    let value = e.target.value;

    if (type === "number" || type === "tel") {
      if (isPercentageMax100) {
        if (value < 1) {
          value = 1;
        } else if (value > 100) {
          value = 100;
        }
      }
    }

    setTempValue(value);
  };

  const handleSaveChange = () => {
    setEdit(false, indeks, property);
    setValue(tempValue, indeks, property);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
    const formattedDate = `${date.getDate()}.${
      date.getMonth() + 1
    }.${date.getFullYear()}`;
    setTempValue(formattedDate);
  };

  useEffect(() => {
    if (autosave) {
      setValue(tempValue, indeks, property);
    }
  }, [tempValue]);

  useEffect(() => {
    if (changeTo == "qty" && type == "number") {
      setTempValue(changeTo);
    }
  }, [changeTo]);

  return (
    <>
      {!edit ? (
        <h4 className={changed ? "__changed" : null}>{result}</h4>
      ) : type && type === "textarea" ? (
        <textarea
          name="textarea"
          value={tempValue}
          onChange={(e) => handleChange(e)}
          className={"custom__input"}
          autoFocus
        ></textarea>
      ) : type && type === "date" ? (
        <DatePicker
          selected={startDate}
          onChange={handleDateChange}
          dateFormat="dd.MM.yyyy"
          className="custom__input"
          autoFocus
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
      ) : (
        <input
          type={type === "number" ? "tel" : "text"}
          placeholder={placeholder ? placeholder : ""}
          value={tempValue}
          onChange={(e) => handleChange(e)}
          disabled={disable}
          className={
            "custom__input " + (type === "number" ? "input__number" : "")
          }
          autoFocus
        />
      )}
      {!edit ? (
        <>
          {/* <EditIcon style={{ marginLeft: 20, cursor: "pointer", color: "#476355"  }} onClick={()=>handleEdit()}/> */}
        </>
      ) : (
        <>
          {/* <CheckIcon style={{ marginLeft: 20, cursor: "pointer" }}
                    onClick={() => handleSaveChange()}/>
                <CloseIcon style={{ marginLeft: 8, cursor: "pointer" }}
                    onClick={()=> setEdit(false,indeks,property)}/> */}
        </>
      )}
    </>
  );
};

export default EditableResultList;
